module.exports = __webpack_public_path__ + "static/referal-times-two-2a074165b32e3bf824a40aacab226374.png";